import { r as subscribeToKlaviyoList, t as EMAIL_PATTERN } from "./app.shared-Bm7KCbEG.js";

var mapGender = value => {
    switch (value) {
      case "mens":
        return "Male";

      case "womens":
        return "Female";

      case "both":
        return "Both";

      default:
        return "Both";
    }
};

var newsletter_form_default = (() => {
    if (!customElements.get("newsletter-form")) customElements.define("newsletter-form", class NewsletterForm extends HTMLElement {
        form=null;
        statusEl=null;
        submitButton=null;
        connectedCallback() {
            this.form = this.querySelector("form");
            this.statusEl = this.querySelector("[data-status]");
            this.submitButton = this.querySelector('button[type="submit"]');
            this.form?.addEventListener("submit", this.onSubmit);
        }
        disconnectedCallback() {
            this.form?.removeEventListener("submit", this.onSubmit);
        }
        get companyId() {
            return this.dataset.companyId || window.MBF?.settings?.klaviyoCompanyId || "";
        }
        get source() {
            return this.dataset.source || "";
        }
        get listId() {
            return (this.dataset.listId || "").trim();
        }
        setStatus(message) {
            if (this.statusEl) this.statusEl.textContent = message || "";
        }
        onSubmit=async event => {
            event.preventDefault();
            const companyId = this.companyId;
            const listId = this.listId;
            if (!companyId || !listId) {
                console.warn("[newsletter-form] Missing company id or list id; submission skipped.");
                return;
            }
            const emailInput = this.form.querySelector('input[type="email"]');
            const email = emailInput?.value?.trim();
            if (!email || !EMAIL_PATTERN.test(email)) {
                emailInput?.setAttribute("aria-invalid", "true");
                emailInput?.focus();
                this.setStatus(window.MBF?.strings?.newsletter?.invalidEmail || "");
                return;
            }
            emailInput.removeAttribute("aria-invalid");
            this.setStatus("");
            const interestCategories = mapGender(this.form.querySelector('input[name="gender"]:checked')?.value);
            if (this.submitButton) this.submitButton.disabled = true;
            try {
                await subscribeToKlaviyoList({
                    companyId: companyId,
                    listId: listId,
                    email: email,
                    source: this.source || "newsletter",
                    properties: {
                        "Interest Categories": interestCategories
                    }
                });
                this.form.reset();
                this.setStatus(window.MBF?.strings?.newsletter?.success || "");
                this.dispatchEvent(new CustomEvent("newsletter:subscribed", {
                    bubbles: true,
                    detail: {
                        email: email,
                        source: this.source,
                        listId: listId
                    }
                }));
            } catch (error) {
                console.error("[newsletter-form] Submission failed:", error);
                this.setStatus("");
                document.dispatchEvent(new CustomEvent("toast:show", {
                    detail: {
                        message: window.MBF?.strings?.newsletter?.error || ""
                    }
                }));
            } finally {
                if (this.submitButton) this.submitButton.disabled = false;
            }
        };
    });
})();